import { useEffect, useState } from "react";
import { copy } from "../copy";
import { pickKey, useLandingFeed, type Pick } from "../feed";
import BetSlip from "../components/BetSlip";
import EarningsCalculator from "../components/EarningsCalculator";
import SiteFooter from "../components/SiteFooter";

// /earnings-calculator: the homepage calculator on a page of its own, with
// the explainer text a search engine indexes. Go serves the shell with the
// same title and a description, canonical, and preview tags.
export default function EarningsCalculatorPage() {
  const t = copy.calculatorPage;
  const feed = useLandingFeed();
  const [selection, setSelection] = useState<Pick | null>(null);

  useEffect(() => {
    document.title = t.title;
  }, [t.title]);

  return (
    <div
      className={`min-h-screen overflow-x-hidden bg-ground font-sans text-chrome antialiased ${selection ? "lg:pr-80" : ""}`}
    >
      <main>
        <EarningsCalculator page contests={feed?.liveContests ?? []} onBack={setSelection} />

        <section data-testid="calculator-explainer" className="border-t border-ground-edge px-4 py-16 md:px-6 md:py-20">
          <div className="mx-auto grid w-full max-w-[1240px] grid-cols-1 gap-12 md:grid-cols-2">
            {t.sections.map((section) => (
              <div key={section.heading}>
                <h2 className="font-headline text-3xl uppercase leading-[0.95] tracking-[-0.01em] text-chrome md:text-4xl">
                  {section.heading}
                </h2>
                {section.body.map((p) => (
                  <p key={p} className="mt-4 text-sm leading-relaxed text-chrome-dim md:text-base">
                    {p}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </section>

        <section className="border-t border-ground-edge bg-ground-raised px-4 py-16 md:px-6 md:py-20">
          <div className="mx-auto w-full max-w-3xl">
            <h2 className="font-headline text-3xl uppercase leading-[0.95] tracking-[-0.01em] text-chrome md:text-4xl">
              {t.faqHeading}
            </h2>
            <dl className="mt-8 divide-y divide-ground-edge">
              {t.faq.map((item) => (
                <div key={item.q} className="py-5">
                  <dt className="font-bold text-chrome">{item.q}</dt>
                  <dd className="mt-2 text-sm leading-relaxed text-chrome-dim">{item.a}</dd>
                </div>
              ))}
            </dl>
          </div>
        </section>
      </main>
      <SiteFooter />
      {selection && <BetSlip key={pickKey(selection)} pick={selection} onClose={() => setSelection(null)} />}
    </div>
  );
}
